import { getPointsPath, getReamingPointsPath } from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { pointsActions } from "../reducers/points";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchPointsList = (id) => {
  return (dispatch) => {
    return apiService
      .get(getPointsPath(id))
      .then((response) => {
        dispatch(pointsActions.fetchPointsList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchReamingPointsList = () => {
  return (dispatch) => {
    return apiService
      .get(getReamingPointsPath())
      .then((response) => {
        dispatch(
          pointsActions.fetchReamingPointsList(response.data.remainingPoints)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
